import { Box, Tabs } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import { CustomTab as Tab } from 'components/common/custom-tab';
import React, { FC, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { LoanFormType } from '../../types';
import { Disclosures } from './components/disclosures';
import { Increases } from './components/increases';
import { useStyles } from './styles';

type Props = {
  loanForm: UseFormReturn<LoanFormType, object>,
  isDataLoading: boolean,
  onSave: (e?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
}

// eslint-disable-next-line no-shadow
enum TabValue {
  termsAndDates = 'terms-and-dates',
  increases = 'increases',
  disclosure = 'disclosure'
}

export const TermsAndDatesIncreasesDisclosure: FC<Props> = ({
  loanForm,
  isDataLoading,
  onSave
}) => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<TabValue>(TabValue.increases);
  const classes = useStyles();

  return (
    <TabContext value={selectedTab}>
      <Box>
        <Tabs value={selectedTab} onChange={(e, value: TabValue) => { setSelectedTab(value); }}>
          <Tab
            value={TabValue.increases}
            text={t('loan:increases')}
            currentValue={selectedTab}
          />
          <Tab
            value={TabValue.disclosure}
            text={t('loan:disclosures')}
            currentValue={selectedTab}
          />
        </Tabs>

        <>
          <TabPanel value={TabValue.increases} className={classes.panelcontainer}>
            <Increases
              loanForm={loanForm}
              onSave={onSave}
            />
          </TabPanel>
          <TabPanel value={TabValue.disclosure} className={classes.panelcontainer}>
            <Disclosures
              loanForm={loanForm}
              isDataLoading={isDataLoading}
              onSave={onSave}
            />
          </TabPanel>
        </>
      </Box>
    </TabContext>
  );
};
